/* eslint-disable no-dupe-keys */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Card, CircularProgress, Divider, useMediaQuery } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import ReactTimeAgo from "react-time-ago";
import actions from "../../Redux Store/actions";
import {
  getLeadTokens,
  getPreselectPaymentConfig,
  getPriorityPassTokens,
  getTokenPaymentLink,
  refundTokenPayment,
  getTokenServerTime,
  priorityPassToken,
  getPreselectTokenData,
  createTokenPaymentLink,
  eventTokenPaymentLink,
} from "../../Services/Tokens";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import cssClasses from "./Tokens.module.css";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { errorTost, successTost } from "../../Services/Toast";
import ViewDetails from "../ViewDetails/ViewDetails";
import { supabase } from "../../supabaseClient";
import EmptyListIcon from "../../Assets/Images/EmptyDataIcons/Tokens.svg";
import QrCode from "qrcode";
import {
  createPaymentOrder,
  getPyamentLink,
  sdrPaymentMode,
} from "../../Services/Allotment";
import MyTimer from "../../Subcomponents/Timer";
import Button from "../../Subcomponents/Button";
import RefundToken from "../../Modals/RefundToken/RefundToken";
import { makeStyles } from "@mui/styles";
import VjLogo from "../../Assets/Images/Common/VjLogo.svg";

import html2pdf from "html2pdf.js";
import TokenPayment from "../../Modals/TokenPayment/TokenPayment";
import BuyToken from "../../Modals/BuyToken/BuyToken";
import LinkedToken from "../../Modals/LinkedToken/LinkedToken";
import TokenIcon from "../../Assets/Images/Token/token.svg";
import BoughtOnIcon from "../../Assets/Images/Token/boughton.svg";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import BookingForm from "../../Modals/BookingForm/BookingForm";
import DropDown from "../../Subcomponents/DropDown";
import ValidTillIcon from "../../Assets/Images/Token/valid.svg";
import {
  tokenPaymentComplete,
  numberWithCommas,
} from "../../Assets/Common/CommonFunctions";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  wrapperPage: {
    width: "100%",
    height: "100%",
  },
  header: {
    width: "100%",
    marginBottom: "2rem",
  },
  title: {
    color: "#1C1C1C",
    fontFamily: "Inter-Medium",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: "1rem",
  },
  label: {
    display: "inline-block",
    fontFamily: "Inter-Medium",
    fontWeight: "400",
    fontSize: "1.4rem",
    lineheight: "2rem",
    color: "#667085",
    marginRight: "0.4rem",
  },
  billingDetails: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  boldValues: {
    fontWeight: "800",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: " #434343",
    fontFamily: "Inter-Medium",
  },
  value: {
    color: "#0B062A",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    fontFamily: "Inter-Medium",
  },
  leadName: {
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "1.5rem",
    color: "#434343",
    fontFamily: "Inter-Medium",
  },
  border: {
    border: "2px solid #19AFFF",
    marginTop: "3rem",
    marginBottom: "5rem",
    width: "100%",
  },
  wrapperTable: {
    border: "1px solid #19AFFF",
    borderWidth: "30px 1px 1px 1px",
    padding: "1rem",
    display: "flex",
    justifyContent: "space-between",
    width: " 100%",
    flexDirection: "column",
    gap: "2rem",
  },
  keyValue: {
    display: "flex",
    justifyContent: "space-between",
    width: " 100%",
  },
}));

const Tokens = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [allTokens, setAllTokens] = useState([]);
  const [filterTokens, setFilterTokens] = useState([]);
  const [totalTokens, setTotalTokens] = useState([]);
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  TimeAgo.setDefaultLocale(en.locale);
  TimeAgo.addLocale(en);
  const [showDetails, setShowDetails] = useState(false);
  const [openTokenPaymentModal, setOpenTokenPaymentModal] = useState(false);
  const [tokenObj, setTokenObj] = useState({});
  const [tokensPresent, setTokensPresent] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);
  const [openRefundModal, setOpenRefundModal] = useState(false);
  const selectedLead = JSON.parse(localStorage.getItem("selectedLead"));
  const [openBuyTokenModal, setOpenBuyTokenModal] = useState(false);
  const [upgradableTokens, setUpgradableTokens] = useState([]);
  const [prereqToken, setPrereqToken] = useState(null);
  const [openLinkedTokenModal, setOpenLinkedTokenModal] = useState(false);
  const [serverTime, setServerTime] = useState("");
  const [showBulkRefund, setShowBulkRefund] = useState(false);
  const [selectedTokenPaymentData, setSelectedTokenPaymentData] =
    useState(null);
  const [currentAllotmentPayment, setCurrentAllotmentPayment] = useState();
  const [openBookingFormModal, setOpenBookingFormModal] = useState(false);
  const [ppTokenIds, setPPTokenIds] = useState([]);
  const [sort, setSort] = useState("All");
  const allotmentDetail = useRef({});

  // for online booking
  // --- Online Booking Config ---
  const [eventStartDate, setEventStartDate] = useState(null);
  const [eventEndDate, setEventEndDate] = useState(null);
  const [isEventActive, setIsEventActive] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [timerActive, setTimerActive] = useState(false);

  useEffect(() => {
    dispatch(actions.activeMenu("tokens"));
    getTokens();

    let updateUnitListener = supabase
      .from(`EventTokenLeadRelations:leadId=eq.${loggedInUser.leadId}`)
      .on("UPDATE", (handleRecordUpdated) => {
        const newDataIndex = allTokens.findIndex(
          (e) => e.paymentId === handleRecordUpdated.new.paymentId
        );
        if (newDataIndex !== -1) {
          //Cheking data is found or not
          let newData = [...allTokens];
          newData[newDataIndex]["payId"] = handleRecordUpdated.new.payId;
          newData[newDataIndex]["paidAmount"] =
            handleRecordUpdated.new.paidAmount;
          newData[newDataIndex]["status"] = handleRecordUpdated.new.status;
          newData[newDataIndex]["last_updated_at"] =
            handleRecordUpdated.new.last_updated_at;
          if (
            handleRecordUpdated.new.status === "Refund Initiated" ||
            handleRecordUpdated.new.status === "Refund Processed"
          ) {
            newData[newDataIndex]["menuOpt"] = ["No Actions Available"];
          }
          setAllTokens(newData);
        } else {
          getTokens();
        }
      })
      .subscribe((status) => {});

    let deleteUnitListener = supabase
      .from(`EventTokenLeadRelations`)
      .on("DELETE", (handleRecordUpdated) => {
        if (handleRecordUpdated.new.leadId === loggedInUser.leadId) {
          getTokens();
        }
      })
      .subscribe((status) => {});
    let updateAllotmentListener = supabase
      .from(`AllotmentPayment:leadId=eq.${loggedInUser.leadId}`)
      .on("UPDATE", (handleRecordUpdated) => {
        if (handleRecordUpdated.new.pricingType === "preselect") {
          const preselectTokenIndex = allTokens?.findIndex(
            (token) => token.paymentId === handleRecordUpdated.new.paymentId
          );
          if (preselectTokenIndex !== -1) {
            let newData = [...allTokens];
            newData[preselectTokenIndex]["kycFormFilled"] =
              handleRecordUpdated.new.kycFormFilled;
            setAllTokens(newData);
          } else {
            getTokens();
          }
        }
      })
      .subscribe((status) => {});

    let insertUnitListener = supabase
      .from(`EventTokenLeadRelations`)
      .on("INSERT", (handleRecordUpdated) => {
        if (handleRecordUpdated.new.leadId === loggedInUser.leadId) {
          getTokens();
        }
      })
      .subscribe((status) => {});

    return () => {
      if (insertUnitListener) {
        supabase.removeSubscription(insertUnitListener);
        insertUnitListener = null;
      }
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
      if (deleteUnitListener) {
        supabase.removeSubscription(deleteUnitListener);
        deleteUnitListener = null;
      }
      if (updateAllotmentListener) {
        supabase.removeSubscription(updateAllotmentListener);
        updateAllotmentListener = null;
      }
    };
  }, [loggedInUser]);

  useEffect(() => {
    if (ppTokenIds.length > 0) {
      // ! add snapshot for priority pass dates
      // ? subscribed for all events hence commented
      let addEventTokenListener = supabase
        .from(`EventTokens`)
        .on("INSERT", (handleRecordUpdated) => {
          console.log(handleRecordUpdated);
          if (ppTokenIds.includes(handleRecordUpdated.new.prerequisiteId)) {
            getTokens();
          }
        })
        .subscribe((status) => {});
      let updateEventTokenListener = supabase
        .from(`EventTokens:prerequisiteId=in.(${ppTokenIds})`)
        .on("UPDATE", (handleRecordUpdated) => {
          console.log(handleRecordUpdated);
          getTokens();
        })
        .subscribe((status) => {});
      return () => {
        if (addEventTokenListener) {
          supabase.removeSubscription(addEventTokenListener);
          addEventTokenListener = null;
        }
        if (updateEventTokenListener) {
          supabase.removeSubscription(updateEventTokenListener);
          updateEventTokenListener = null;
        }
      };
    }
  }, [ppTokenIds]);
  const getServerTime = async () => {
    getTokenServerTime()
      .then((res) => {
        setServerTime(res?.data?.currentTime);
      })
      .catch((error) => {
        console.log("err in serverTime api call", error);
      });
  };

  useEffect(() => {
    getServerTime();
  }, []);

  function getTokens() {
    presentLoader();
    setTotalTokens(0);
    getTokenServerTime().then((res) => {
      let time = res?.data?.currentTime;
      setServerTime(res?.data?.currentTime);
      getLeadTokens(loggedInUser.leadId)
        .then((resp) => {
          // console.log("token lead relation code --->", resp);

          // let allTokens = [...resp.data];
          // ? get prerequisite tokens from resp
          // ? link it with upgraded token
          const prerequisiteTokens = resp.data.filter((data) => {
            if (data.isPrerequisiteUsed) return data;
          });
          let allTokens = resp.data.filter((data) => {
            if (!data.isPrerequisiteUsed) return data;
          });
          // ! get tokens whose pre-requisite tokens are bought by lead
          const tokenIds = [];

          // console.log("allTokens ----->", allTokens);
          allTokens.forEach((token) => {
            //
            token.isPrerequisiteAvailable = false;
            token.prerequisiteMsg = "";
            token.upgradableTokens = [];
            token.timer = null;
            token.showPPBtn = false;
            token.closeTimer = null;
            // if (token.paidAmount >= token.amount) {
            tokenIds.push(token.eventTokenId.eventTokenId);
            setPPTokenIds(tokenIds);
            token.upgradedFrom =
              prerequisiteTokens.find((tk) => {
                if (token.paymentId === tk.linkedTokenId.paymentId) {
                  return tk;
                }
              }) ?? null;
          });
          getPriorityPassTokens(tokenIds).then((prereqResp) => {
            // ! if new token is available; show 'Priority Pass Available' button
            prereqResp.data.forEach((ppToken) => {
              allTokens = allTokens.map((token, index) => {
                if (
                  token.eventTokenId.eventTokenId === ppToken.prerequisiteId
                ) {
                  //token.isPrerequisiteAvailable = false;
                  //token.startPaymentFrom = ppToken.startPaymentFrom
                  // ? when priority pass is available
                  if (
                    ppToken.startPaymentFrom <= time &&
                    time < ppToken.expirePaymentOn
                  ) {
                    token.prerequisiteMsg =
                      "Priority Pass available. Complete payment before " +
                      new Date(ppToken.expirePaymentOn).toLocaleString() +
                      " to avail Priority Pass!";
                    // ? check if prerequisite token amount is paid
                    if (token.paidAmount >= token.amount) {
                      token.isPrerequisiteAvailable = true;
                      token.startPaymentFrom = ppToken.startPaymentFrom;
                      token.prerequisiteMsg = "";
                      token.showPPBtn = true;
                      token.upgradableTokens.push(ppToken);
                      token.closeTimer = ppToken.expirePaymentOn;
                    }
                  }
                  // ? if priority pass payment has not started
                  if (ppToken.startPaymentFrom > time) {
                    token.prerequisiteMsg =
                      "Priority Pass will be available from " +
                      new Date(ppToken.startPaymentFrom).toLocaleString() +
                      " . Complete payment before " +
                      new Date(ppToken.expirePaymentOn).toLocaleString() +
                      " to avail Priority Pass!";
                    // ? check if prerequisite token amount is paid
                    if (token.paidAmount >= token.amount) {
                      token.isPrerequisiteAvailable = true;
                      token.startPaymentFrom = ppToken.startPaymentFrom;
                      if (ppToken.startTimerFrom > time) {
                        setTimeout(() => {
                          token.timer = ppToken.startPaymentFrom;
                          token.closeTimer = ppToken.expirePaymentOn;
                          setAllTokens((pre) => {
                            pre[index].timer = ppToken.startPaymentFrom;
                            pre[index].closeTimer = ppToken.expirePaymentOn;
                            pre[index].showPPBtn = false;

                            return [...pre];
                          });
                        }, ppToken.startTimerFrom - time);
                      } else {
                        token.timer = ppToken.startPaymentFrom;
                        token.closeTimer = ppToken.expirePaymentOn;
                      }
                      token.prerequisiteMsg =
                        "Priority Pass will be available from " +
                        new Date(ppToken.startPaymentFrom).toLocaleString() +
                        "!";
                      token.upgradableTokens.push(ppToken);
                    }
                  }
                }
                return token;
              });
              return;
            });

            allTokens = allTokens.map((token) => {
              let menuOpt = [];
              if (token.eventTokenId.tokenId.isPreselect) {
                const tokenBuyDate = new Date(token.created_at);
                tokenBuyDate.setTime(
                  tokenBuyDate.getTime() +
                    process.env.REACT_APP_TOKEN_EXPIRY_TIME * 60000
                );
                token.validity = `${new Date(
                  tokenBuyDate
                ).toDateString()}, ${new Date(tokenBuyDate).toLocaleTimeString(
                  [],
                  {
                    hour: "2-digit",
                    minute: "2-digit",
                  }
                )}`;
              } else {
                const tokenBuyDate = new Date(token.created_at);
                tokenBuyDate.setDate(
                  tokenBuyDate.getDate() + token.eventTokenId.tokenId.validity
                );
                token.validity = `${new Date(
                  tokenBuyDate
                ).toDateString()}, ${new Date(tokenBuyDate).toLocaleTimeString(
                  [],
                  {
                    hour: "2-digit",
                    minute: "2-digit",
                  }
                )}`;
              }
              if (
                token?.eventTokenId?.tokenId?.canCustomerRefund &&
                (token.status === "active" || token.status === "partial")
              ) {
                menuOpt.push("Refund Token");
              }
              if (token.paidAmount < token.amount) {
                menuOpt.push("View Token");
                if (token.eventTokenId.tokenId.isPreselect) {
                  token.expiry =
                    token.created_at +
                    process.env.REACT_APP_TOKEN_EXPIRY_TIME * 60000;
                } else if (token.eventTokenId.tokenId.isPriorityPass) {
                  token.expiry = token.eventTokenId.expirePaymentOn;
                } else {
                  token.expiry =
                    token.created_at +
                    process.env.REACT_APP_TOKEN_EXPIRY_TIME * 60000;
                }

                return { ...token, menuOpt };
              } else {
                if (
                  token.status === "refund requested" ||
                  token.status === "refund initiated" ||
                  token.status === "refunded" ||
                  token.status === "refund processed"
                ) {
                  menuOpt.push("No Actions Available");
                } else {
                  menuOpt.push("View Token");
                }
                // ! commented as per trello card client request
                // if (!token.eventTokenId.tokenId.isPreselect && (token.status === 'alloted' || token.status === 'active')) {
                //     //  ? if token amount is not to be adjusted in booking amount, then allow to raise refund request
                //     if (!token.eventId?.adjustTokenAmt)
                //         menuOpt.push("Request Refund");
                //     // menuOpt.push("Download Receipt");

                // }
                return { ...token, menuOpt };
              }
            });
            setAllTokens(allTokens);
            setTotalTokens(allTokens.length);
            dismissLoader();
          });
        })
        .catch((err) => {
          errorTost("Could not get tokens!");
          dismissLoader();
        });
    });
  }

  useEffect(() => {
    if (totalTokens > 0) {
      allTokens.forEach((e, i) => {
        if (e.eventTokenId.tokenId.isPreselect) {
          getPreselectTokenData(e.paymentId).then((projectDetailsRes) => {
            let obj = projectDetailsRes[0];
            let unitType = obj?.unitId?.projectId.customerDisplayInventoryType
              ? obj?.unitId?.projectId.customerDisplayInventoryType.length === 2
                ? `${obj?.unitId.inventoryTypeId.type} (${obj?.unitId.displayUnitType})`
                : obj?.unitId?.projectId.customerDisplayInventoryType.includes(
                    "Inventory Type"
                  )
                ? obj?.unitId?.inventoryTypeId.type
                : obj?.unitId?.displayUnitType
              : `${obj?.unitId?.inventoryTypeId.type} (${obj?.unitId?.displayUnitType})`;
            setAllTokens((pre) => {
              pre[i].allotmentPaymentId = obj;
              pre[i].kycFormFilled = obj?.kycFormFilled;
              if (obj?.unitId) {
                pre[
                  i
                ].projectDetails = `${obj?.unitId?.projectId.projectName} | ${obj?.unitId?.wingId.wingName} | ${obj?.unitId?.floorNo} | ${obj?.unitId?.unitNo} | ${unitType}`;
              } else {
                pre[
                  i
                ].projectDetails = `${obj?.inventoryMergedId.unit1Id.projectId.projectName} | ${obj?.inventoryMergedId.unit1Id.wingId.wingName} | ${obj?.inventoryMergedId.unit1Id.floorNo} - ${obj?.inventoryMergedId.unit2Id.floorNo} | ${obj?.inventoryMergedId.unit1Id.unitNo} - ${obj?.inventoryMergedId.unit2Id.unitNo} | Merged Unit`;
              }
              return [...pre];
            });
          });
        }
        if (i === allTokens.length - 1) {
          setTokensPresent(true);
        }
      });
    } else {
      setTokensPresent(false);
    }
  }, [totalTokens]);

  useEffect(() => {
    setFilterTokens(allTokens);
  }, [allTokens]);

  function returnRes(value) {}
  function openTokenPayment(token) {
    presentLoader();
    getTokenPaymentLink(token.TokenTransactions[0]?.paymentLinkId)
      .then((resp) => {
        if (resp.data.success) {
          window.open(resp.data.link, "_blank");
          dismissLoader();
        }
      })
      .catch((err) => {
        errorTost("Could not open payment link. Try again later!");
        dismissLoader();
      });
  }
  const handlePayment = async (token) => {
    const options = {
      key: process.env.REACT_APP_RAZOR_PAY_KEY, // Enter the Key ID generated from the Dashboard
      // ? token amount for preselect token as well
      // ! vedashree to change this amount
      amount: (token.amount - token.paidAmount) * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: "INR",
      name: "VJ Developers",
      partial_payment: true,
      description: "Payment for token " + token.tokenNumber,
      order_id: "order_LU6yaBGBSxE0Ra", //This is a sample Order ID. Pass the `id` obtained in the response of createOrder().
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.on("payment.failed", function (response) {
      // ?todo: show loader modal
    });
    rzp1.open();
  };

  function requestTokenRefund(token) {
    setOpenRefundModal(true);
  }

  function addPriorityPasstoken(ppTokenData) {
    presentLoader();
    const ppObj = {
      eventTokenId: ppTokenData,
      gtPaymentId: prereqToken.paymentId,
      leadId: selectedLead.leadId,
      paidAmount: 0,
      amount: ppTokenData.tokenId.amount,
      TokenTransactions: [],
    };

    setSelectedToken(ppObj);
    priorityPassToken(ppObj)
      .then((ppResp) => {
        if (ppResp?.data?.success?.length > 0) {
          setSelectedToken((pre) => {
            pre.paymentId = ppResp.data.success[0].paymentId;
            return { ...pre };
          });
          // setSelectedToken(ppResp.data.success[0]);
          dismissLoader();
          setOpenBuyTokenModal(false);
          setOpenTokenPaymentModal(true);
        } else {
          errorTost("Try again in sometime!");
          dismissLoader();
        }
      })
      .catch((err) => {
        console.log("err: ", err);
        dismissLoader();
        errorTost("Network Error. Please try again later!");
      });
  }

  async function updateTokenTables(amt) {
    presentLoader();
    setOpenTokenPaymentModal(false);
    // !todo 1. check if token is preselect
    // !todo 2. if preselect, get payment settings from event settings
    // !todo 3. if not preselect, get payment settings from settings tab
    if (selectedToken.eventTokenId.tokenId.isPreselect) {
      getPreselectPaymentConfig(selectedToken.eventId.eventId)
        .then(async (config) => {
          if (config[0].preselectPaymentModes.includes("Customer In-App")) {
            const obj = {
              transactionObj: {
                transactionType: "preselect",
                modeOfPayment: "Razorpay-Customer Portal",
                allotmentPaymentId:
                  selectedToken.allotmentPaymentId?.allotmentPaymentId,
                unitId: selectedToken?.allotmentPaymentId?.unitId?.unitId,
                inventoryMergeId:
                  selectedToken?.allotmentPaymentId?.inventoryMergedId
                    ?.inventoryMergeId,
                leadId: selectedToken.leadId,
                status: "pending",
                amount: amt,
              },
              amount: amt,
              type: "Allotment",
            };
            await createPaymentOrder(obj)
              .then(async (order) => {
                if (order?.data?.success) {
                  dismissLoader();
                  const options = {
                    key: process.env.REACT_APP_RAZOR_PAY_KEY,
                    amount: amt * 100,
                    currency: "INR",
                    name: "VJ Developers",
                    partial_payment: true,
                    description:
                      "Payment for token " + selectedToken.tokenNumber,
                    order_id: order.data.id,
                  };
                  const rzp1 = new window.Razorpay(options);
                  rzp1.open();
                } else if (order?.data?.message) {
                  dismissLoader();
                  errorTost(order?.data?.message);
                } else {
                  dismissLoader();
                  errorTost("Couldn't create order! please try again later");
                }
              })
              .catch((err) => {
                console.log("err: ", err);
                dismissLoader();
                errorTost("Network Error. Please try again later!");
              });
          } else if (config[0].preselectPaymentModes.includes("Razorpay")) {
            await createTokenPaymentLink(amt, "allotment", selectedToken)
              .then((create) => {
                if (create.data.success) {
                  getTokenPaymentLink(create.data.paymentLinkId)
                    .then((resp) => {
                      setSelectedToken(null);
                      getTokens();
                      successTost(
                        "Payment link sent on registered mobile number!"
                      );
                      let anchor = document.createElement("a");
                      anchor.href = resp.data.link;
                      anchor.target = "_blank";
                      anchor.click();
                      dismissLoader();
                    })
                    .catch((err) => {
                      console.log("err: ", err);
                      dismissLoader();
                      errorTost("Network Error. Please try again later!");
                    });
                } else {
                  errorTost(create.data.message);
                }
              })
              .catch((err) => {
                console.log("err: ", err);
                dismissLoader();
                errorTost("Create Payment Failed! Please try again later");
              });
          }
        })
        .catch((err) => {
          console.log("err: ", err);
          dismissLoader();
          errorTost(
            "Error While getting Preselect Details! Please try again later"
          );
        });
    } else {
      sdrPaymentMode()
        .then(async (resp) => {
          const currentDate = new Date();
          if (resp.data[0].useLinkInCustomerAppForToken) {
            eventTokenPaymentLink(amt, selectedToken)
              .then((create) => {
                if (create.data.success) {
                  getPyamentLink(create.data.paymentLinkId)
                    .then((resp) => {
                      if (resp.data) {
                        setSelectedToken(null);
                        getTokens();
                        successTost(
                          "Payment link sent on registered mobile number!"
                        );
                        let anchor = document.createElement("a");
                        anchor.href = resp.data.link;
                        anchor.target = "_blank";
                        anchor.click();
                        dismissLoader();
                      } else {
                        dismissLoader();
                        errorTost(
                          "Couldn't create order! please try again later"
                        );
                      }
                    })
                    .catch((err) => {
                      dismissLoader();
                      console.log(
                        "Couldn't create order! please try again later"
                      );
                    });
                } else {
                  dismissLoader();
                  errorTost(create.data.message);
                }
              })
              .catch((err) => {
                dismissLoader();
                console.log("Couldn't create order! please try again later");
              });
          } else {
            const obj = {
              amount: amt,
              type: "Token",
              transactionObj: {
                eventTokenId: selectedToken.eventTokenId.eventTokenId,
                paymentId: selectedToken.paymentId,
                leadId: selectedToken.leadId,
                status: "pending",
                amount: amt,
              },
            };
            await createPaymentOrder(obj)
              .then(async (order) => {
                if (order?.data?.success) {
                  dismissLoader();
                  const options = {
                    key: process.env.REACT_APP_RAZOR_PAY_KEY, // Enter the Key ID generated from the Dashboard
                    // amount: token.eventTokenId.tokenId.isPreselect ? 50000000 : (token.amount - token.paidAmount) * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                    // ? token amount for preselect token as well
                    // ! vedashree to change this amount
                    amount: amt * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                    currency: "INR",
                    name: "VJ Developers",
                    partial_payment: true,
                    description:
                      "Payment for token " + selectedToken.tokenNumber,
                    order_id: order.data.id,
                    handler: function (response) {},
                  };

                  const rzp1 = new window.Razorpay(options);
                  rzp1.open();
                } else {
                  dismissLoader();
                  errorTost("Couldn't create order! please try again later");
                }
              })
              .catch((err) => {
                console.log("err: ", err);
                dismissLoader();
                errorTost("Network Error. Please try again later!");
              });
          }
        })
        .catch((err) => {
          console.log("err: ", err);
          dismissLoader();
          errorTost("Network Error. Please try again later!");
        });
    }
  }

  const handleRefundToken = () => {
    presentLoader();
    let body = {
      mode: "Token",
      paymentId: tokenObj?.paymentId,
    };
    refundTokenPayment(body)
      .then((respRefundTokenPay) => {
        if (respRefundTokenPay?.data?.success?.length) {
          setShowBulkRefund(false);
          successTost("Token refund initiated successfully!");
          getTokens();
          dismissLoader();
        } else if (respRefundTokenPay?.data?.failed?.length) {
          setShowBulkRefund(false);
          errorTost(respRefundTokenPay?.data?.failed[0]?.reason);
          getTokens();
          dismissLoader();
        }
      })
      .catch((err) => {
        setShowBulkRefund(false);
        errorTost(err?.data?.message);
        dismissLoader();
      });
  };

  const handleChange = (event) => {
    const status = event;
    setSort(status);
    if (status === "All") {
      setFilterTokens(allTokens);
      setTokensPresent(true);
    } else {
      if (status === "Preselected") {
        const selectedItem = allTokens.filter(
          (item) =>
            item.status === "alloted" && item.eventTokenId.tokenId.isPreselect
        );
        setFilterTokens(selectedItem);
        selectedItem.length > 0
          ? setTokensPresent(true)
          : setTokensPresent(false);
      } else {
        const selectedItem = allTokens.filter(
          (item) => item.status === status.toLowerCase()
        );
        setFilterTokens(selectedItem);
        selectedItem.length > 0
          ? setTokensPresent(true)
          : setTokensPresent(false);
      }
    }
    // console.log(filterTokens);
  };

  const menuItem = [
    "All",
    "Preselected",
    "Pending",
    "Partial",
    "Active",
    "Alloted",
    "Refund Initiated",
    "Refund Requested",
    "Refund Processed",
    "Refund Rejected",
    "Expired",
    "Adjusted",
  ];

  //   changes done for online booking
  // Calculate time remaining
  //   useEffect(() => {
  //     const computeRemaining = () => {
  //       if (!serverClock || !eventStartDate) {
  //         return { finished: false, text: "Loading..." };
  //       }
  //       // Corrected here
  //       const now = Date.now() - offset; // Simulate server time
  //       const diff = new Date(eventStartDate).getTime() - now; // Corrected here

  //       if (diff <= 0) return { finished: true, text: "0d : 0hrs : 0min : 0s" };

  //       const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  //       const hours = Math.floor(
  //         (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  //       );
  //       const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  //       const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  //       return {
  //         finished: false,
  //         text: `${days}d : ${hours}hrs : ${minutes}min : ${seconds}s`,
  //       };
  //     };

  //     const initial = computeRemaining();
  //     setTimeRemaining(initial.text);
  //     setIsTimerFinished(initial.finished);

  //     const updateTimer = () => {
  //       const updated = computeRemaining();
  //       setTimeRemaining(updated.text);
  //       setIsTimerFinished(updated.finished);
  //     };

  //     const interval = setInterval(updateTimer, 1000);
  //     return () => clearInterval(interval);
  //   }, [serverClock, offset]);

  const [loading, setLoading] = useState(false);

  const handleBooking = async (token) => {
    setLoading(true);
    try {
      if (isEventActive === false) {
        navigate("/Home/Tokens");
        return;
      }

      if (isEventActive === true) {
        const res = await axios.post(
          `${process.env.REACT_APP_PAYMENT_LINK_URL}customerOnlineBooking/getAllUnitsFromLaunchesForCustomerFastBooking`
        );

        // console.log("response of whole inventory ===> ", res);

        if (res.data?.data) {
          navigate("/Home/UnitFloorMap", {
            state: {
              data: res.data.data,
              paymentId: token?.paymentId,
              tokenNo: token?.tokenNumber,
            },
          });
        }
      }
    } catch (error) {
      console.error("Error fetching units:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchOnlineBookingConfig() {
      // console.log("all tokens", allTokens);

      try {
        const body = { eventId: "aa91780c-5a31-415f-aca3-1527bfc4522a" };
        const response = await axios.post(
          `${process.env.REACT_APP_PAYMENT_LINK_URL}customerOnlineBooking/getEventOnlineBookingConfigDetails`,
          body
        );
        // console.log("response---->", response);

        const config = response?.data;
        // console.log("config---->", config);
        // console.log("config start date ---->", config.data.startDate);

        if (config) {
          setEventStartDate(config?.data?.startDate);
          setEventEndDate(config?.data?.endDate);
          setIsEventActive(config?.data?.isOnlineBookingAccept);
        }
      } catch (err) {
        console.error("Error fetching OnlineBookingConfig:", err);
      }
    }

    fetchOnlineBookingConfig();
  }, []);

  useEffect(() => {
    if (!serverTime || !eventStartDate || !eventEndDate) return;

    const start = Number(eventStartDate);
    const end = Number(eventEndDate);
    const initialTime = Date.now();
    const offset = initialTime - serverTime;

    const interval = setInterval(() => {
      const now = Date.now() - offset;

      if (now < start) {
        // Booking not started yet
        const diff = start - now;
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        setTimeRemaining(`${days}d ${hours}h ${minutes}m ${seconds}s`);
        setTimerActive(true);
      } else if (now >= start && now <= end) {
        // Booking window open
        setTimerActive(false);
        setTimeRemaining(null);
      } else if (now > end) {
        // Booking closed
        setTimerActive(false);
        setTimeRemaining(null);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [serverTime, eventStartDate, eventEndDate]);

  // end of code for onliner booking

  return (
    <>
      <div className={cssClasses.wrapperTargetPage}>
        {/* <div style={{ display: "flex", flexWrap: isWrap ? "wrap" : "nowrap" }}> */}
        <div className={cssClasses.mainContent}>
          <div className={cssClasses.headerMainContent}>
            <div className={cssClasses.wrapperHeader}>
              <div className={cssClasses.wrapperTitleUserName}>
                <div className={cssClasses.headerTitle}>
                  {filterTokens.length} Tokens
                </div>
              </div>
            </div>
            {(tokensPresent || allTokens.length > 0) && (
              <div className={cssClasses.searchData}>
                <div className={cssClasses.dropdownWrapper}>
                  <DropDown
                    onChangeSelect={(e) => {
                      handleChange(e);
                    }}
                    selectedValue={sort}
                    style={{
                      selectedColor: "#657084",
                      background: "#F2F4F7",
                    }}
                    list={menuItem}
                  />
                </div>
              </div>
            )}
          </div>
          <div className={cssClasses.eventsWrapper}>
            {/* {console.log("filter tokens----->", filterTokens)} */}
            {tokensPresent &&
              filterTokens.map((token) => (
                <Card className={cssClasses.eventWrap} key={token.paymentId}>
                  <div
                    style={{
                      width: "100%",

                      display: "flex",
                      flexDirection: "column",
                      gap: "1.6rem",
                    }}
                  >
                    <div className={cssClasses.cardHeader}>
                      <div className={cssClasses.cardHeaderSection}>
                        <div className={cssClasses.tokenNumberImgData}>
                          <img src={TokenIcon} alt="token" />
                          <div className={cssClasses.tokenNumWrap}>
                            <div className={cssClasses.tokenNumWrapcontent}>
                              {token.paidAmount === token.amount && (
                                <span>VJ{token.tokenNumber}</span>
                              )}
                              <span className={cssClasses.tokenNoData}>
                                {token.eventTokenId.tokenId.name}
                              </span>
                            </div>
                            <div className={cssClasses.tokenStatus}>
                              {token.status === "pending" && (
                                <LeadStatusChip
                                  label={token.status}
                                  icon={
                                    <Dot width={"0.5rem"} height={"0.5rem"} />
                                  }
                                  style={{
                                    color: "rgb(181, 71, 8)",
                                    backgroundColor: "rgb(255, 250, 235)",
                                  }}
                                ></LeadStatusChip>
                              )}
                              {token.status === "partial" && (
                                <LeadStatusChip
                                  label={token.status}
                                  icon={
                                    <Dot width={"0.5rem"} height={"0.5rem"} />
                                  }
                                  style={{
                                    color: "#B42318",
                                    backgroundColor: "#FEF3F2",
                                  }}
                                ></LeadStatusChip>
                              )}
                              {token.status === "active" && (
                                <LeadStatusChip
                                  label={token.status}
                                  icon={
                                    <Dot width={"0.5rem"} height={"0.5rem"} />
                                  }
                                  style={{
                                    color: "#027A48",
                                    backgroundColor: "#ECFDF3",
                                  }}
                                ></LeadStatusChip>
                              )}
                              {token.status === "alloted" &&
                                !token.eventTokenId.tokenId.isPreselect && (
                                  <LeadStatusChip
                                    label={token.status}
                                    icon={
                                      <Dot width={"0.5rem"} height={"0.5rem"} />
                                    }
                                    style={{
                                      color: "#C11574",
                                      backgroundColor: "#FDF2FA",
                                    }}
                                  ></LeadStatusChip>
                                )}
                              {token.status === "alloted" &&
                                token.eventTokenId.tokenId.isPreselect && (
                                  <LeadStatusChip
                                    label={"Preselected"}
                                    icon={
                                      <Dot width={"0.5rem"} height={"0.5rem"} />
                                    }
                                    style={{
                                      color: "#C11574",
                                      backgroundColor: "#FDF2FA",
                                    }}
                                  ></LeadStatusChip>
                                )}
                              {(token.status === "refund requested" ||
                                token.status === "Upgraded" ||
                                token.status === "refund initiated") && (
                                <LeadStatusChip
                                  label={token.status}
                                  icon={
                                    <Dot width={"0.5rem"} height={"0.5rem"} />
                                  }
                                  style={{
                                    color: "#B54708",
                                    backgroundColor: "#FFFAEB",
                                  }}
                                ></LeadStatusChip>
                              )}
                              {(token.status === "refunded" ||
                                token.status === "refund processed" ||
                                token.status === "adjusted") && (
                                <LeadStatusChip
                                  label={token.status}
                                  icon={
                                    <Dot width={"0.5rem"} height={"0.5rem"} />
                                  }
                                  style={{
                                    color: "#E62E05",
                                    backgroundColor: "#FFF4ED",
                                  }}
                                ></LeadStatusChip>
                              )}
                              {token.status === "expired" && (
                                <LeadStatusChip
                                  label={token.status}
                                  icon={
                                    <Dot width={"0.5rem"} height={"0.5rem"} />
                                  }
                                  style={{
                                    color: "#0E7090",
                                    backgroundColor: "#ECFDFF",
                                  }}
                                ></LeadStatusChip>
                              )}
                              {token.status === "cancelled" && (
                                <LeadStatusChip
                                  label={token.status}
                                  icon={
                                    <Dot width={"0.5rem"} height={"0.5rem"} />
                                  }
                                  style={{
                                    color: "#B42318",
                                    backgroundColor: "#FEF3F2",
                                  }}
                                ></LeadStatusChip>
                              )}
                              {token.status === "refund rejected" && (
                                <LeadStatusChip
                                  style={{
                                    color: "#5925DC",
                                    backgroundColor: "#F4F3FF",
                                  }}
                                  label={token.status}
                                  icon={
                                    <Dot width={"0.5rem"} height={"0.5rem"} />
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={cssClasses.cardHeaderSectionTwo}>
                        <div className={cssClasses.tokenLastUpdate}>
                          <ReactTimeAgo
                            style={{ fontSize: "1.2rem" }}
                            date={token?.last_updated_at ?? token?.created_at}
                            locale="en-US"
                          />
                        </div>
                        <div className={cssClasses.tokenActions}>
                          {token.menuOpt.length > 0 && (
                            <ThreeDotsMenu
                              list={token.menuOpt}
                              selectedValue={(e) => {
                                setTokenObj(token);

                                if (e === "View Token") {
                                  QrCode.toDataURL(token.paymentId)
                                    .then((resp) => {
                                      token.qrUrl = resp;
                                      setTokenObj(token);
                                      setShowDetails(true);
                                    })
                                    .catch((err) => {
                                      console.log("err: ", err);
                                    });
                                } else if (e === "Refund Token") {
                                  setTokenObj(token);
                                  setShowBulkRefund(true);
                                } else if (e === "Open Payment Link") {
                                  openTokenPayment(token);
                                } else if (e === "Pay Now") {
                                  setTokenObj(token);
                                  handlePayment(token);
                                } else if (e === "Request Refund") {
                                  setTokenObj(token);
                                  requestTokenRefund(token);
                                }
                                // else if (e === "Download Receipt") {
                                //     setTokenObj(token);
                                //     downloadReceipt(token);
                                // }
                                else if (e === "Download Receipt") {
                                  var element =
                                    document.getElementById(
                                      "reportTemplateRef"
                                    );
                                  var opt = {
                                    margin: 1,
                                    filename: "Receipt.pdf",
                                    image: {
                                      type: "jpeg",
                                      quality: 0.98,
                                    },
                                    html2canvas: {
                                      scale: 1,
                                    },
                                    jsPDF: {
                                      unit: "in",
                                      format: "letter",
                                      orientation: "portrait",
                                    },
                                  };
                                  html2pdf().set(opt).from(element).save();
                                }
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={cssClasses.cardDetails}>
                    <div className={cssClasses.tokenDetails}>
                      <div className={cssClasses.detailsHeader}>
                        <div
                          className={cssClasses.tokenData}
                          style={{
                            justifyContent: "space-between",
                          }}
                        >
                          <div className={cssClasses.eventTitle}>
                            <span>{token.eventId.title}</span>
                          </div>
                        </div>
                        {/* <div>
												<div>
													{token.eventTokenId.tokenId.isPreselect && (
														<span>
															<LeadStatusChip
																label={"Preselect"}
																style={{
																	color: "#FF7B01",
																	border: "1px solid #FFC997",
																	borderRadius: "0px",
																}}
															></LeadStatusChip>
														</span>
													)}
												</div>
											</div> */}
                      </div>
                      {token.eventTokenId.tokenId.isPreselect && (
                        <div
                          className={cssClasses.tokenData}
                          style={{
                            justifyContent: "space-between",
                          }}
                        >
                          <span>{token.projectDetails}</span>
                        </div>
                      )}
                      <div className={cssClasses.tokenBoughtSection}>
                        <div className={cssClasses.tokenBoughtData}>
                          <span
                            style={{
                              display: "flex",
                              gap: "0.4rem",
                            }}
                          >
                            <img src={BoughtOnIcon} alt="token" />
                            Bought on :
                          </span>
                          <span style={{ fontWeight: "600" }}>
                            {new Date(token.created_at).toDateString()},{" "}
                            {new Date(token.created_at).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </span>
                        </div>
                        <div className={cssClasses.tokenBoughtData}>
                          {/* <span
														style={{
															display: "flex",
															gap: "0.4rem",
														}}
													>
														<img src={ValidTillIcon} alt="token" />
														Valid Till :
													</span>
													<span style={{ fontWeight: "600" }}>{token.validity}</span> */}
                        </div>
                      </div>
                      {token.paidAmount >= token.amount &&
                        token?.TokenTransactions?.length > 0 && (
                          <div className={cssClasses.tokenBoughtSection}>
                            <div className={cssClasses.tokenBoughtData}>
                              <span
                                style={{
                                  display: "flex",
                                  gap: "0.4rem",
                                }}
                              >
                                <img src={ValidTillIcon} alt="token" />
                                Token Payment Complete :
                              </span>
                              <span style={{ fontWeight: "600" }}>
                                {tokenPaymentComplete(token.TokenTransactions)}
                              </span>
                            </div>
                          </div>
                        )}
                      {/* <Divider flexItem /> */}
                    </div>
                  </div>
                  <>
                    {token.expiry && (
                      <>
                        {token.expiry > serverTime &&
                          token.paidAmount === 0 &&
                          !token.eventTokenId.tokenId.isPreselect && (
                            <div className={cssClasses.timerWrapSection}>
                              <div className={cssClasses.timerWrap}>
                                Expires In
                                <MyTimer
                                  showIcon={false}
                                  css={{
                                    fontSize: "1.8rem",
                                    color: "#B42318",
                                  }}
                                  expiryTimestamp={token.expiry}
                                  onExpire={() => {
                                    setOpenTokenPaymentModal(false);
                                    token.expiry = null;
                                  }}
                                />
                              </div>
                            </div>
                          )}
                      </>
                    )}
                  </>
                  <div className={cssClasses.cardFooter}>
                    <div className={cssClasses.tokenTotalAmount}>
                      <div className={cssClasses.totalAmt}>
                        <span
                          style={{
                            fontSize: "1.2rem !important",
                          }}
                        >
                          TOKEN AMOUNT{" "}
                        </span>
                        {token.eventTokenId.tokenId.isPriorityPass && (
                          <span className={cssClasses.tokenAmtPaid}>
                            ₹{" "}
                            {numberWithCommas(
                              token.amount +
                                (token.upgradedFrom
                                  ? token.upgradedFrom.amount
                                  : 0)
                            )}
                          </span>
                        )}
                        {!token.eventTokenId.tokenId.isPriorityPass && (
                          <span className={cssClasses.tokenAmtPaid}>
                            ₹ {numberWithCommas(token.amount)}
                          </span>
                        )}
                        {/* } */}
                      </div>
                      {((token.paidAmount > 0 &&
                        !token.eventTokenId.tokenId.isPriorityPass) ||
                        token.eventTokenId.tokenId.isPriorityPass) && (
                        <>
                          <Divider orientation="vertical" flexItem />
                          <div className={cssClasses.paidAmt}>
                            <div>PAID AMOUNT </div>
                            {token.eventTokenId.tokenId.isPriorityPass && (
                              <div className={cssClasses.tokenAmtPaid}>
                                ₹{" "}
                                {numberWithCommas(
                                  token.paidAmount +
                                    (token.upgradedFrom
                                      ? token.upgradedFrom.paidAmount
                                      : 0)
                                )}
                              </div>
                            )}
                            {!token.eventTokenId.tokenId.isPriorityPass && (
                              <span className={cssClasses.tokenAmtPaid}>
                                ₹ {numberWithCommas(token.paidAmount)}
                              </span>
                            )}

                            {/* )} */}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className={cssClasses.cardFooterBtnData}>
                    <div className={cssClasses.btnView}>
                      {(token.status === "alloted" ||
                        token.status === "refund rejected") &&
                        token.eventTokenId.tokenId.isPreselect &&
                        !token.kycFormFilled && (
                          <div style={{ display: "flex" }}>
                            <Button
                              btnName={"Fill KYC"}
                              clicked={() => {
                                allotmentDetail.current =
                                  token.allotmentPaymentId;
                                setCurrentAllotmentPayment(
                                  token.allotmentPaymentId
                                );
                                setOpenBookingFormModal(true);
                              }}
                              style={{
                                width: "12rem",
                                color: "#fff",
                                backgroundColor: "rgb(21, 112, 239)",
                                fontSize: "1.4rem",
                                lineHeight: "2rem",
                                fontFamily: "Inter-Medium !important",
                              }}
                            ></Button>
                          </div>
                        )}

                      <div className={cssClasses.confirmBtnWrap}>
                        {/* {!token.eventTokenId.tokenId.isPreselect && !token.eventTokenId.tokenId.isPriorityPass && ( */}
                        {token.expiry && (
                          <>
                            {!token.eventTokenId.tokenId.isPreselect && (
                              <>
                                {((token.paidAmount === 0 &&
                                  token.expiry > serverTime) ||
                                  (token.paidAmount > 0 &&
                                    token.paidAmount < token.amount)) &&
                                  !token.status.includes("refund") && (
                                    <>
                                      <Button
                                        btnName={"Pay Now"}
                                        clicked={() => {
                                          if (
                                            token.eventTokenId.tokenId
                                              .isPriorityPass
                                          ) {
                                            // ! limit is checked based on this token's eventTokenId
                                            setSelectedTokenPaymentData(
                                              token.eventTokenId
                                            );
                                          } else {
                                            setSelectedTokenPaymentData(null);
                                          }
                                          setTokenObj(token);
                                          // if (token.eventTokenId.tokenId.isPreselect) {
                                          setSelectedToken(token);
                                          setOpenTokenPaymentModal(true);
                                        }}
                                        style={{
                                          width: "fit-content",
                                          color: "#fff",
                                          backgroundColor: "rgb(21, 112, 239)",
                                          fontSize: "1.4rem",
                                          lineHeight: "2rem",
                                          fontFamily: "Inter-Medium !important",
                                        }}
                                      ></Button>
                                    </>
                                  )}
                              </>
                            )}
                          </>
                        )}

                        {token.eventTokenId.tokenId.isPreselect &&
                          !token.eventTokenId.tokenId.isPriorityPass &&
                          (token.allotmentPaymentId?.status?.includes(
                            "Payment Pending"
                          ) ||
                            token.allotmentPaymentId?.status?.includes(
                              "Partial Payment Done"
                            ) ||
                            token.allotmentPaymentId?.status?.includes(
                              "Preselected"
                            )) && (
                            <>
                              {(token.paidAmount === 0 ||
                                (token.paidAmount > 0 &&
                                  token.paidAmount < token.amount)) && (
                                <>
                                  <Button
                                    btnName={"Pay Now"}
                                    clicked={() => {
                                      setTokenObj(token);
                                      setSelectedToken(token);
                                      setOpenTokenPaymentModal(true);
                                    }}
                                    style={{
                                      width: "fit-content",
                                      color: "#fff",
                                      backgroundColor: "rgb(21, 112, 239)",
                                      fontSize: "1.4rem",
                                      lineHeight: "2rem",
                                      fontFamily: "Inter-Medium !important",
                                    }}
                                  ></Button>
                                </>
                              )}
                            </>
                          )}
                      </div>

                      {/* online booking code starts */}

                      {/* --- Online Booking Section --- */}
                      {isEventActive &&
                        token?.status === "active" &&
                        (token?.eventId?.eventId ===
                          "8d7e356a-e502-45fb-a170-4628d32f6f8b" ||
                          token?.eventId?.eventId ===
                            "aa91780c-5a31-415f-aca3-1527bfc4522a") &&
                        token?.eventId?.EventOnlineBookingConfig[0]
                          ?.isOnlineBookingAccept ===
                          true && (
                            <>
                              {timeRemaining && timerActive && (
                                <div
                                  className={cssClasses.tokenButtonContent}
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  <div
                                    style={{
                                      color: "#fff",
                                      backgroundColor: "#1570EF",
                                      fontSize: "1.4rem",
                                      lineHeight: "2rem",
                                      display: "flex",
                                      flexDirection: "column",
                                      padding: "5px",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    <div>Booking Starts In</div>
                                    <div>{timeRemaining}</div>
                                  </div>
                                </div>
                              )}

                              {!timerActive &&
                                eventStartDate &&
                                eventEndDate &&
                                isEventActive === true &&
                                token?.eventId?.EventOnlineBookingConfig[0]
                                  ?.isOnlineBookingAccept === true && (
                                  <>
                                    {serverTime >= eventStartDate &&
                                    serverTime <= eventEndDate ? (
                                      <div
                                        className={
                                          cssClasses.tokenButtonContent
                                        }
                                        style={{ justifyContent: "flex-end" }}
                                      >
                                        <Button
                                          btnName={
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                minWidth: "120px",
                                              }}
                                            >
                                              {loading ? (
                                                <CircularProgress
                                                  size={22}
                                                  sx={{ color: "white" }}
                                                />
                                              ) : (
                                                "BOOK NOW"
                                              )}
                                            </div>
                                          }
                                          clicked={() => handleBooking(token)}
                                          disabled={loading}
                                          style={{
                                            color: "#fff",
                                            backgroundColor: "#1570EF",
                                            fontSize: "1.4rem",
                                            lineHeight: "2rem",
                                            fontFamily:
                                              "Inter-Medium !important",
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <div style={{ height: "40px" }}></div>
                                    )}
                                  </>
                                )}
                            </>
                          )}

                      {/* online booking code ends */}

                      {token.isPrerequisiteAvailable &&
                        token.status === "active" && (
                          <div className={cssClasses.confirmBtnWrap}>
                            {token.timer && !token.isPrerequisiteUsed && (
                              <div className={cssClasses.timerWrap}>
                                Priority Pass starts at{" "}
                                <MyTimer
                                  css={{
                                    fontSize: "1.8rem",
                                    color: "#98A2B3",
                                  }}
                                  expiryTimestamp={token.timer}
                                  onExpire={() => {
                                    token.showPPBtn = true;
                                    token.timer = null;
                                  }}
                                />
                              </div>
                            )}
                            {!token.isPrerequisiteUsed &&
                              token.timer <= serverTime &&
                              serverTime < token.closeTimer && (
                                <div className={cssClasses.timerWrap}>
                                  Priority Pass closes in{" "}
                                  <MyTimer
                                    css={{
                                      fontSize: "1.8rem",
                                      color: "#98A2B3",
                                    }}
                                    expiryTimestamp={token.closeTimer}
                                    onExpire={() => {
                                      token.showPPBtn = false;
                                      token.closeTimer = null;
                                      setOpenBuyTokenModal(false);
                                    }}
                                  />
                                </div>
                              )}
                            {token.showPPBtn && (
                              <Button
                                btnName={"Buy Priority Pass Now"}
                                clicked={() => {
                                  setTokenObj(token);
                                  setUpgradableTokens(token.upgradableTokens);
                                  setPrereqToken(token);
                                  setOpenBuyTokenModal(true);
                                }}
                                style={{
                                  width: "fit-content",
                                  color: "#fff",
                                  backgroundColor: "rgb(21, 112, 239)",
                                  fontSize: "1.4rem",
                                  lineHeight: "2rem",
                                  fontFamily: "Inter-Medium !important",
                                }}
                              ></Button>
                            )}
                          </div>
                        )}
                      {token.upgradedFrom && (
                        <div className={cssClasses.confirmBtnWrap}>
                          <Button
                            btnName={"View Linked Token"}
                            clicked={() => {
                              setTokenObj(token);
                              setOpenLinkedTokenModal(true);
                            }}
                            style={{
                              width: window.innerWidth > 1366 ? "100%" : "100%",
                              color: "#344054",
                              backgroundColor: "#fff",
                              fontSize: "1.4rem",
                              lineHeight: "2rem",
                              fontFamily: "Inter-Medium !important",
                              borderRadius: "8px",
                              border: "1px solid #D0D5DD",
                              boxShadow:
                                "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                              fontWeight: "500",
                              width: "auto",
                            }}
                          ></Button>
                        </div>
                      )}
                    </div>
                  </div>
                </Card>
              ))}
            {tokensPresent === false && (
              <div className={cssClasses.noDataWrapper}>
                <div className={cssClasses.noDataMsg}>
                  <div className={cssClasses.emptyIcon}>
                    <img src={EmptyListIcon} alt="No Tokens" />
                  </div>
                  <div className={cssClasses.emptyTitle}>
                    No tokens to show!
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* <div style={{ display: "flex", flexDirection: "column", margin: "3rem", gap: "1rem", width: isWrap ? "100%" : "30%" }}>
						<SalesManagerCard style={{ width: "100%" }} />
						<VirtaulAccountCard />
					</div> */}
        {/* </div> */}
        {showDetails && (
          <ViewDetails
            open={showDetails}
            handleClose={() => {
              setShowDetails(false);
            }}
            data={tokenObj}
            returnRes={returnRes}
          />
        )}
        {showBulkRefund && (
          <ConfirmationAlert
            confirm={(e) => {
              if (e === "confirmed") {
                handleRefundToken();
              }
            }}
            buttonTitle={"Cancel"}
            returnRespButton={"Continue"}
            close={() => {
              setShowBulkRefund(false);
            }}
            title={"Warning"}
            refundFlag={true}
            subTitle={`Are you sure! Do you want to Refund this token ?`}
            open={showBulkRefund}
          />
        )}
        {openRefundModal && (
          <RefundToken
            open={openRefundModal}
            handleClose={() => {
              setOpenRefundModal(false);
            }}
            refundTokenData={tokenObj}
            data={loggedInUser}
            returnRes={returnRes}
          />
        )}
        {openTokenPaymentModal && (
          <TokenPayment
            payableTokenData={selectedTokenPaymentData}
            open={openTokenPaymentModal}
            tokenPaymentResponse={updateTokenTables}
            tokenDetails={selectedToken}
            handleClose={() => {
              setOpenTokenPaymentModal(false);
              setSelectedToken(null);
            }}
          />
        )}
        {openBuyTokenModal && (
          <BuyToken
            open={openBuyTokenModal}
            handleClose={() => {
              setOpenBuyTokenModal(false);
            }}
            availableTokens={upgradableTokens}
            tokenSelectionResponse={(token) => {
              setSelectedTokenPaymentData(token);
              // addTokenPayment(token);
              // !vedashree changes
              addPriorityPasstoken(token);
              // ! gaurav changes
              // presentLoader();
              // let obj = {
              //   token: token,
              //   leadId: selectedLead.leadId,
              //   paymentId: prereqToken.paymentId
              // }
              // setTokenObj(selectedData);
              // setSelectedToken(selectedData);

              // dismissLoader()
              // ! sarita changes
              // ${process.env.REACT_APP_PAYMENT_LINK_URL}
              // axios.post(` ${process.env.REACT_APP_PAYMENT_LINK_URL}priorityPass/enqueue`, obj).then((resp) => {
              //
              //   //  let abc = setInterval(async () => {
              //   //   await getQueueStatus(resp).then((response)=>{
              //   //
              //   //   if (response.data.status === 'complete'){
              //   //     dismissLoader();
              //   //     clearInterval(abc);
              //   //     if(!response.data.success){
              //   //
              //   //       errorTost(`You cannot buy ${token?.tokenId?.name} now as the limit has exceeded!`);
              //   //     }
              //   //   }
              //   //   }).catch((err)=>{
              //   //
              //   //   });
              //   //  }, 1000);
              //   // ??Recursive calls until we get response as res.data.status === 'complete'
              //   // getQueueStatusRecursive(resp, token?.tokenId?.name);
              //   dismissLoader()
              // }).catch((err) => {
              //   dismissLoader();
              //
              // });
            }}
          />
        )}
        {openLinkedTokenModal && (
          <LinkedToken
            open={openLinkedTokenModal}
            handleClose={() => {
              setOpenLinkedTokenModal(false);
            }}
            selectedToken={tokenObj}
          />
        )}
        {openBookingFormModal && (
          <BookingForm
            allotment={allotmentDetail.current}
            open={openBookingFormModal}
            handleClose={() => {
              setOpenBookingFormModal(false);
            }}
          />
        )}
      </div>
      <div>
        {/* Download Invoice Pdf */}
        <div style={{ display: "none" }}>
          <div id={"reportTemplateRef"} className={classes.wrapperPage}>
            <div className={classes.header}>
              <img src={VjLogo} alt={"Logo"} />
            </div>
            <div className={classes.billingDetails}>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexDirection: "column",
                }}
              >
                <span className={classes.boldValues}>Billed to:</span>
                <div className={classes.leadName}>
                  {loggedInUser?.personId?.name}
                </div>
                <div className={classes.leadName}>
                  {loggedInUser?.personId?.email}
                </div>
                <div className={classes.leadName}>
                  +{loggedInUser?.personId?.contactNumber}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexDirection: "column",
                }}
              >
                <div className={classes.boldValues}>Date Issued:</div>
                <div className={classes.leadName}>
                  {new Date(serverTime).toDateString()},{" "}
                  {new Date(serverTime).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div>
                <div className={classes.boldValues}>Brought On:</div>
                <div className={classes.leadName}>
                  {new Date(tokenObj.created_at).toDateString()},{" "}
                  {new Date(tokenObj.created_at).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div>
              </div>
            </div>
            <div className={classes.border}></div>
            <div className={classes.wrapperTable}>
              <div className={classes.keyValue}>
                <span className={classes.value}>Event Name:</span>
                <span className={classes.value}>
                  {tokenObj?.eventId?.title}
                </span>
              </div>
              <div className={classes.keyValue}>
                <span className={classes.value}>Token Number:</span>
                <span className={classes.value}>VJ{tokenObj?.tokenNumber}</span>
              </div>
              <div className={classes.keyValue}>
                <span className={classes.value}>Token Status :</span>
                <span className={classes.value}>
                  {tokenObj?.status?.toUpperCase()}
                </span>
              </div>

              <div className={classes.keyValue}>
                <span className={classes.boldValues}>Total Amount :</span>
                <span className={classes.boldValues}>
                  ₹{numberWithCommas(tokenObj.amount)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tokens;
